import { useEffect, useRef } from 'react';
import { useGlobalStore } from '@/stores';
import { CashOut } from '@/features/income/components/CashOut';
import { IncomeOrders } from '@/features/income/components/IncomeOrders';
import { IncomeChart } from '@/features/income/components/IncomeChart';

export default function IncomePage() {
    const setBreadcrumbs = useGlobalStore(state => state.setBreadcrumbs);
    const ordersRef = useRef<{ refetch: () => void } | null>(null);

    useEffect(() => {
        setBreadcrumbs([{ title: 'My Income', to: '/income', id: 'income', active: true }]);
    }, [setBreadcrumbs]);

    const handleCashoutSuccess = () => {
        // Refresh orders after successful cashout
        ordersRef.current?.refetch();
    };

    return (
        <>
            <div className='mb-8 flex flex-col gap-4 lg:flex-row lg:gap-18'>
                <IncomeChart className='flex-1' />
                <CashOut
                    className='max-w-128 max-lg:w-full max-lg:max-w-full'
                    onCashoutSuccess={handleCashoutSuccess}
                />
            </div>
            <div className='mt-4'>
                <IncomeOrders ref={ordersRef} />
            </div>
        </>
    );
}
